export default __webpack_public_path__ + "static/media/Search.ee93dfd9.svg";